// hooks
import { useTranslation } from 'react-i18next';

// styles
import { Typography } from '@mui/material';
import { Container } from './NoData.styles';
import Kbd from 'components/shared/Typography/Kbd/Kbd';
import { MrpShortcuts } from 'components/mrp/mrp.consts';

const NoData = () => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  return (
    <Container>
      <Typography variant="h4" color="text.secondary">
        {t('noDataPlaceholder')}
      </Typography>
      <Kbd
        keys={[
          ...MrpShortcuts.OPEN_CALENDAR.controllerKeys,
          MrpShortcuts.OPEN_CALENDAR.activatorKey
        ]}
      />
    </Container>
  );
};
export default NoData;
